import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
} from '@digital-retail/design-system';
import PropTypes from 'prop-types';
import constants from '../../config/constants';
import { withApplicationContext } from '../../utils/ApplicationContext';
import { noop } from '../../utils/noop';
import ShippingTooltipStyles from './ShippingTooltip.style';

const ShippingTooltip = ({ isOpen, deliveryType, onClose }) => {
  const message =
    deliveryType === constants.AVAILABILITY_EXPRESS
      ? 'Para esta cantidad, la entrega será con envío rápido.'
      : 'Para esta cantidad, la entrega será con envío programado.';
  return (
    <Popover placement="top" isOpen={isOpen} onClose={onClose}>
      <PopoverTrigger>
        <button type="button" />
      </PopoverTrigger>
      <PopoverContent className="shipping-tooltip">
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverHeader>Cambio en la entrega del producto</PopoverHeader>
        <PopoverBody>{message}</PopoverBody>
        <style jsx>{ShippingTooltipStyles}</style>
      </PopoverContent>
    </Popover>
  );
};

ShippingTooltip.propTypes = {
  isOpen: PropTypes.bool,
  deliveryType: PropTypes.string,
  onClose: PropTypes.func,
};

ShippingTooltip.defaultProps = {
  isOpen: false,
  deliveryType: '',
  onClose: noop,
};

export { ShippingTooltip };
export default withApplicationContext(ShippingTooltip);
